import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import AdminDashboard from "./admin/Dashboard";
import AdminLogin from "./admin/Login";
import ThemeToggle from "./components/ThemeToggle";
import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from "./context/ThemeContext";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <Preloader load={load} />
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <ScrollToTop />
          <Routes>
            {/* Public Portfolio Routes */}
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
                <ThemeToggle />
                <Analytics />
              </>
            } />
            <Route path="/project" element={
              <>
                <Navbar />
                <Projects />
                <Footer />
                <ThemeToggle />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <About />
                <Footer />
                <ThemeToggle />
              </>
            } />
            <Route path="/resume" element={
              <>
                <Navbar />
                <Resume />
                <Footer />
                <ThemeToggle />
              </>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            <Route path="*" element={<Navigate to="/"/>} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}


export default App;
